import { Button } from "shared/ui/button";
import { useScrollLock } from "shared/lib/hooks";
import { EventRegistrationModal } from "features";
import { EventRegistrationButton } from "features";
import { useModal } from "shared/ui/modal";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import MapPin from "shared/assets/images/Map_pin.svg";
import styles from "./EventSidebar.module.scss";

export const EventSidebar = ({
  isCollapsed,
  open,
  close,
  toggle,
  loginSidebarOpen,
}) => {
  useScrollLock(!isCollapsed);

  const {
    isModalOpen: isEventRegistrationModalOpen,
    open: openEventRegistrationModal,
    close: closeEventRegistrationModal,
    toggle: toggleEventRegistrationModal,
  } = useModal(false);

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      close?.();
    }
  };

  return (
    <>
      {isCollapsed ? null : (
        <div className={styles.sidebarOverlay} onClick={handleOverlayClick}>
          <div className={styles.sidebarContainer}>
            <div className={styles.sidebarWrapper}>
              <div className={styles.buttons}>
                <Button
                  variant="ghost"
                  size="small"
                  leftIcon={<img src={MapPin} alt="map pin" height={26} />}
                  onClick={openDisabledElementModal}
                >
                  Самара
                </Button>
              </div>
              <div className={styles.links}>
                <a href="#about" className={styles.links__link} onClick={close}>
                  О мероприятии
                </a>
                <a
                  href="#experts"
                  className={styles.links__link}
                  onClick={close}
                >
                  Эксперты
                </a>
                <a
                  href="#partners"
                  className={styles.links__link}
                  onClick={close}
                >
                  Партнеры
                </a>
                <a
                  href="#program"
                  className={styles.links__link}
                  onClick={close}
                >
                  Программа
                </a>
                <a href="#venue" className={styles.links__link} onClick={close}>
                  Место проведения
                </a>
                <a
                  href="#questions"
                  className={styles.links__link}
                  onClick={close}
                >
                  Вопросы
                </a>
                <a
                  className={styles.links__link}
                  onClick={openDisabledElementModal}
                >
                  Контакты
                </a>
              </div>
              <div className={styles.sidebarWrapper__buttonBlock}>
                <div className={styles.sidebarWrapper__centerBtn}>
                  <EventRegistrationButton
                    variant="primary"
                    openModal={openEventRegistrationModal}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <EventRegistrationModal
        isModalOpen={isEventRegistrationModalOpen}
        open={openEventRegistrationModal}
        close={closeEventRegistrationModal}
        toggle={toggleEventRegistrationModal}
      />
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
